import { render, staticRenderFns } from "./v-mainHeader.vue?vue&type=template&id=6b671ee6&"
import script from "./v-mainHeader.vue?vue&type=script&lang=js&"
export * from "./v-mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./v-mainHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports